import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'PricingCategoriesEditor' }

interface Tier { min_players: number | null; max_players: number | null; price: number | string | null }
interface Category {
  category: string
  pricing: Tier[]
  minimum_participants: number | null
  maximum_participants: number | null | undefined
  default_participants: number | null
  [key: string]: any
}


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    categories: null,
    errors: { default: () => ({}) },
    title: { default: 'Categories' },
    addLabel: { default: 'Add category' },
    setKey: { default: 'default' },
    layout: { default: 'stacked' }
  },
  setup(__props: any) {

const props = __props as { categories: Category[], errors: Record<number, any>, title: string, addLabel: string, setKey: string, layout: 'stacked' | 'rows' }

// Shared pricing categories editor: category name and participant limits on one
// line, then the price tiers. The `categories` array is edited in place (same
// convention as the booking drawer views); the host owns validation and
// persistence. Errors use the shape returned by validateSlotPricing in
// src/util/slotPricingValidation.js. A category always keeps at least one tier
// and the list always keeps at least one category: nothing priced can be saved empty.


function toNumber(v: any): number | null {
  if (v === '' || v === null || v === undefined) return null
  const n = Number(v)
  return Number.isFinite(n) ? n : null
}

function getMinPlayers(pricing: Tier[], index: number): number {
  if (index === 0) return 1
  const prev = Number(pricing[index - 1].max_players)
  return Number.isFinite(prev) ? prev + 1 : 1
}

function addCategory() {
  props.categories.push({
    category: '',
    pricing: [{ min_players: 1, max_players: 10, price: 0 }],
    minimum_participants: 0,
    maximum_participants: null,
    default_participants: 1
  })
}

function removeCategory(index: number) {
  if (props.categories.length > 1) props.categories.splice(index, 1)
}

function addTier(cat: Category) {
  const last = cat.pricing[cat.pricing.length - 1]
  const lastMax = last ? Number(last.max_players) : 0
  cat.pricing.push({
    min_players: (Number.isFinite(lastMax) ? lastMax : 0) + 1,
    max_players: (Number.isFinite(lastMax) ? lastMax : 0) + 5,
    price: 0
  })
}

function removeTier(pricing: Tier[], index: number) {
  if (pricing.length > 1) pricing.splice(index, 1)
}

function tierError(catIdx: number, tierIdx: number, field: string): string | undefined {
  const c = props.errors ? props.errors[catIdx] : undefined
  return c && c.tiers && c.tiers[tierIdx] ? c.tiers[tierIdx][field] : undefined
}

// One line under the row: the first message among price, min and max
function tierMessage(catIdx: number, tierIdx: number): string {
  return tierError(catIdx, tierIdx, 'price') || tierError(catIdx, tierIdx, 'min_players') || tierError(catIdx, tierIdx, 'max_players') || ''
}

return { __sfc: true,props, toNumber, getMinPlayers, addCategory, removeCategory, addTier, removeTier, tierError, tierMessage }
}

})